module.exports = __webpack_public_path__ + "static/8-8d3446b2b7d505f3352c382fcf03a745.jpeg";